module.exports = __webpack_public_path__ + "img/1722485784813-WhatsApp Image 2024-08-01 at 12.12.23 1.jpeg.3fab2df0.webp";